import { createFileRoute } from '@tanstack/react-router'

import { WebhookEditorPage } from '@/features/integrations/webhook-editor'

export const Route = createFileRoute('/_app/integracoes/webhooks/$webhookId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { webhookId } = Route.useParams()
  return <WebhookEditorPage webhookId={webhookId} />
}
